
export const CookieHubIcon = {

  init: () => {
    CookieHubIcon.handleVisibility()
    window.addEventListener('scroll', CookieHubIcon.handleVisibility)
  },

  handleVisibility: () => {
    const footer = document.querySelector('.footer')
    const icon = document.querySelector('.ch2-icon')

    if (!footer || !icon) return

    const trigger = footer.getBoundingClientRect().top - document.body.offsetHeight

    if (trigger < 0) {
      icon.classList.add("ch2-icon--visible");
    } else {
      icon.classList.remove("ch2-icon--visible");
    }
  },
}
